/** Budget per account — API-laag (/Api/budget). */
import { BACKEND_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

async function vraag(pad, opties = {}) {
  const r = await authFetch(`${BACKEND_URL}${pad}`, {
    ...opties,
    headers: { 'Content-Type': 'application/json', ...(opties.headers || {}) },
    body: opties.body !== undefined ? JSON.stringify(opties.body) : undefined,
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const fout = new Error(typeof d.detail === 'string' ? d.detail : (d.error || `Fout ${r.status}`));
    fout.status = r.status;
    fout.huidig = d.huidig;
    throw fout;
  }
  return d;
}

const q = (jaar) => (jaar ? `?jaar=${encodeURIComponent(jaar)}` : '');

export const budgetApi = {
  overzicht: (jaar) => vraag(`/Api/budget/overzicht${q(jaar)}`),
  detail: (sleutel, jaar) => vraag(`/Api/budget/account/${encodeURIComponent(sleutel)}${q(jaar)}`),
  bewaar: (sleutel, body, jaar) => vraag(`/Api/budget/account/${encodeURIComponent(sleutel)}${q(jaar)}`, { method: 'PUT', body }),
  gewichten: (body, jaar) => vraag(`/Api/budget/gewichten${q(jaar)}`, { method: 'PUT', body }),
  async importTargets(bestand, { jaar, toepassen = false, overschrijf = false, metGelijkend = true, voorstelId } = {}) {
    const p = new URLSearchParams({ toepassen: String(toepassen), overschrijf: String(overschrijf), met_gelijkend: String(metGelijkend) });
    if (jaar) p.set('jaar', String(jaar));
    if (voorstelId) p.set('voorstel_id', voorstelId);
    const r = await authFetch(`${BACKEND_URL}/Api/budget/import-targets-vorig?${p}`, {
      method: 'POST', body: bestand, headers: { 'Content-Type': 'application/octet-stream' },
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) {
      const fout = new Error(typeof d.detail === 'string' ? d.detail : `Importeren mislukt (${r.status})`);
      fout.status = r.status;
      fout.voorstel = d.voorstel;
      throw fout;
    }
    return d;
  },
  herstelImport: (items, jaar) => vraag(`/Api/budget/import-targets-vorig/herstel${q(jaar)}`, { method: 'POST', body: { items } }),
  async export(jaar) {
    const r = await authFetch(`${BACKEND_URL}/Api/budget/export.xlsx${q(jaar)}`);
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      throw new Error(typeof d.detail === 'string' ? d.detail : `Exporteren mislukt (${r.status})`);
    }
    return r.blob();
  },
};
